export default __webpack_public_path__ + "static/media/vae4.b7fa9d7f.png";